export default "__VITE_ASSET__57c8324d__"